import React, { useContext } from 'react';

import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import styled from 'styled-components';

import { AttendanceContext } from '../../context/AttendanceContext';
import AddSessions from '../addSessions/AddSessions';
import AttendanceCsvDownload from '../attendance/AttendanceCsvDownload';

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    color: white;
    background-color: ${(props) => props.theme.colors.primary.main};
    height: 60px;
    padding: 0.5rem 1rem;
`;

const HeaderIcon = styled.div`
    flex: 0 0 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 
        0px 3px 5px -1px rgb(0 0 0 / 20%), 
        0px 6px 10px 0px rgb(0 0 0 / 14%), 
        0px 1px 18px 0px rgb(0 0 0 / 12%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.white};

    svg {
        color: ${(props) => props.theme.colors.primary.main};
        max-width: 25px;
        margin-bottom: 1px;
    }
`;

const HeaderTitle = styled.h1`
    flex-shrink: 1;
    margin-left: 1rem;
    font-weight: 300;
    font-size: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

const HeaderControls = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
`;

export interface NavControl {
    label: string;
    onClick: () => void;
}

export interface MainLayoutProps {
    headerControls?: NavControl[];
}

const AttendanceLayout: React.FC<MainLayoutProps> = ({ children }) => {
    const { t, classInfo, classUuid, fetchSessions } = useContext(AttendanceContext);

    return (
        <Container>
            <Header>
                <HeaderIcon>
                    <PersonOutlineIcon />
                </HeaderIcon>
                <HeaderTitle>{t('attendance')}</HeaderTitle>
                <HeaderControls>
                    <AttendanceCsvDownload />
                    <AddSessions
                        classInfo={classInfo}
                        classUuid={classUuid}
                        fetchSessions={fetchSessions}
                    />
                </HeaderControls>
            </Header>
            {children}
        </Container>
    );
};

export default AttendanceLayout;
